import { TenantEntity } from '../TenantEntity'

export class FbaCustomerPrice extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'FbaCustomerPrice'
  }

  get quotationObject() {
    return this._data.quotationObject
  }
  set quotationObject(quotationObject) {
    this._data.quotationObject = quotationObject
  }
  get quotationUuid() {
    return this._data.quotationUuid
  }
  set quotationUuid(quotationUuid) {
    this._data.quotationUuid = quotationUuid
  }
}
